import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {Button} from "react-bootstrap";
import React, {useState} from "react";
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import TextField from '@mui/material/TextField';

function FormDialog(props) {

    const [reason, setReason] = useState("");


    return (
        <Dialog
            open={props.openDialog}
            onClose={props.handleCloseDialog}
            aria-labelledby="responsive-dialog-title">
            <DialogTitle id="responsive-dialog-title" style={{border:'1px solid #dee2e6' , color: 'sandybrown'}}>
                <div>
                    <p style={{ verticalAlign: 'middle', float: 'left',fontSize: 30,margin: 0,paddingTop: 8,color:props.color}}>{props.title}</p>
                    <SpeakerNotesIcon style={{fontSize: 60, float: 'right', color:props.color}}/>
                </div>
            </DialogTitle>
            <DialogContent style={{paddingTop: '10px', paddingBottom: '10px'}}>
                <DialogContentText>
                    {props.dialogContentText}
                </DialogContentText>

            </DialogContent>
            <TextField
                id="outlined-multiline-static"
                label="Açıklama"
                style={{padding:'10px'}}
                multiline
                onChange={(item) => setReason(item.target.value)}
                rows={4}
                variant="outlined"
            />
            <DialogActions style={{borderTop: '1px solid #dee2e6'}}>
                <Button onClick={() => {props.handleAcceptDialog(reason)}} variant="primary" autoFocus>
                    Tamam
                </Button>
                <Button onClick={props.handleCloseDialog} variant="danger">
                    İptal
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default FormDialog;